import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = BASE ? `${BASE}/api` : null;

export async function fetchProducts() {
  if (!API) return [];
  try {
    const res = await axios.get(`${API}/products`);
    return Array.isArray(res.data) ? res.data : [];
  } catch {
    return [];
  }
}

export const money = (n) => `$${Number(n ?? 0).toFixed(2)}`;
